/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsTeamRecordItemDtoSchema = z.object({
  value: z.string().nullish(),
  opponentName: z.string().nullish(),
});
